import * as React from 'react';
import styled from 'styled-components';
import * as Template from './templates';
import LessonViewerContext from '../../LessonViewerContext';
import {
  ContentObject,
  ContentType,
  DocumentValue,
  GalleryValue,
  ImageValue,
  TextValue,
  VideoValue,
} from 'api/lesson/types';

const Container = styled.div`
  margin: 30px 0;
`;

/**
 * This is the content component of the lesson view.
 * @return {React.ReactElement | null}
 * @constructor
 */
export default function Content(): React.ReactElement | null {
  const {content} = React.useContext(LessonViewerContext);

  /**
   * Render template component.
   * @param {ContentObject} object
   * @return {JSX.Element}
   */
  function renderObject(object: ContentObject): JSX.Element {
    switch (object.contentType) {
      case ContentType.Text: return (
        <Template.Text value={object.value as TextValue} />
      );
      case ContentType.Image: return (
        <Template.Image value={object.value as ImageValue} />
      );
      case ContentType.Video: return (
        <Template.Video value={object.value as VideoValue} />
      );
      case ContentType.Document: return (
        <Template.Document value={object.value as DocumentValue} />
      );
      case ContentType.Gallery: return (
        <Template.Gallery value={object.value as GalleryValue} />
      );
    }
  }

  return content ? (
    <React.Fragment>
      {content.map((object, index) => (
        <Container key={index}>
          {renderObject(object)}
        </Container>
      ))}
    </React.Fragment>
  ) : null;
}
